import { Component, inject } from '@angular/core';
import { ITipoListadoCategoria } from 'modelos/src';
import { PermisosEntidadesService } from '../../../../auxiliares/servicios/http/permisos-entidades.service';

@Component({
  selector: 'app-listado-tipos-eventos',
  templateUrl: './listado-tipos-eventos.component.html',
  styleUrl: './listado-tipos-eventos.component.scss',
  standalone: false,
})
export class ListadoTiposEventosComponent {
  private permisos = inject(PermisosEntidadesService);

  /** Tipos de evento filtrados por los módulos visibles del cliente. Gateway es
   * infra LoRaWAN de luminarias → se muestra con el módulo Luminarias, junto con
   * Evento-Luminaria. Nivel 0 ve todos. */
  public categorias: ITipoListadoCategoria[] = this.categoriasHabilitadas();

  private categoriasHabilitadas(): ITipoListadoCategoria[] {
    const cats: ITipoListadoCategoria[] = [];
    if (this.permisos.verModuloAlarmas()) {
      cats.push('Evento-Alarma');
    }
    if (this.permisos.verTrackers()) {
      cats.push('Evento-Tracker');
    }
    if (this.permisos.verModuloLuminarias()) {
      cats.push('Evento-Luminaria');
      cats.push('Evento-Gateway');
    }
    if (this.permisos.verModuloSirenas()) {
      cats.push('Evento-Sirena');
    }
    if (this.permisos.verModuloActivos()) {
      cats.push('Evento-Activo');
    }
    return cats;
  }
}
